module.exports = __webpack_public_path__ + "media/customizations/jubilee/logo-817637957ad6255094f5c5d0031d7041.png";